import { Component, Input } from "@angular/core";
import { AnimationOptions } from "ngx-lottie";
import { SharedService } from "src/app/services/shared.service";

@Component({
  selector: "app-lottie-loader",
  templateUrl: "./lottie-loader.component.html",
  styleUrls: ["./lottie-loader.component.scss"],
})
export class LottieLoaderComponent {
  @Input() size: number = 256;
  lottieOptions: AnimationOptions = {
    path: this.baseURL(),
    autoplay: true,
    loop: true,
  };

  constructor(private sharedService: SharedService) {}

  baseURL() {
    return this.sharedService.getDomainURL() + "/assets/Qjet_new_logo.json";
  }
}
